import { render, staticRenderFns } from "./SideMenuSuc.vue?vue&type=template&id=03cf8c70&scoped=true&"
import script from "./SideMenuSuc.vue?vue&type=script&lang=js&"
export * from "./SideMenuSuc.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuSuc.vue?vue&type=style&index=0&id=03cf8c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cf8c70",
  null
  
)

export default component.exports